export const CONSOLE_LOG = process.env.REACT_APP_ENV !== 'PRODUCTION' ? true : false;

export const URL = process.env.REACT_APP_HOST_COMPANIES_URL;

export const URLsmall = process.env.REACT_APP_HOST_URL;

export const urlBuilder = process.env.REACT_APP_HOST_BUILDER_URL;

export const loginBuilder = process.env.REACT_APP_HOST_LOGIN_BUILDER_URL;

export const urlImg = process.env.REACT_APP_HOST_IMGS_URL;

let domain = window.location.host;

export const LONG_URL = process.env.REACT_APP_HOST_COMPANY_URL + domain;

// xq debo hacer esto ?  -.-
export const ENV2 = process.env.REACT_APP_ENV;



// WEBPACK FOOTER //
// ./src/config.js